import { apiUrl } from 'src/config'

export {
  AUTH_ENDPOINTS,
  ACCOUNT_ENDPOINTS,
  INVITE_ENDPOINTS,
  BANNER_ENDPOINTS,
  SUPPORT_ENDPOINTS,
  USER_ENDPOINTS,
  STORAGE_KEYS,
  API_ERRORS,
  ANALYTICS_EVENTS,
  ERROR_TYPES,
}

const AUTH_ENDPOINTS = {
  AUTH0_LOGIN: apiUrl + '/auth0_login',
  LOAD_ACCOUNT: apiUrl + '/load_account',
  ME: apiUrl + '/me',
  LEAVE_ACCOUNT: apiUrl + '/me/leave-account',
  LOGOUT: apiUrl + '/logout',
}

const ACCOUNT_ENDPOINTS = {
  SETUP: apiUrl + '/account/setup',
  PATCH: apiUrl + '/account',
  RENAME: apiUrl + '/account/rename',
  DELETE: apiUrl + '/account/delete',
}

const INVITE_ENDPOINTS = {
  // Public: verify an invite token to show the landing message. Token is a
  // path segment (URL-encoded at call time).
  VERIFY: (token) => apiUrl + '/invites/' + encodeURIComponent(token),
}

// /sites is the real banner CRUD + scan root. Scan paths are built per-site:
//   POST `${SITES}/${siteId}/scans`        -> trigger a scan
//   GET  `${SITES}/${siteId}/scans/latest` -> poll latest scan status/results
//   GET  `${SITES}/${siteId}/scans/${scanId}` -> fetch a specific scan by id
const BANNER_ENDPOINTS = {
  SITES: apiUrl + '/sites', // POST create, GET list, DELETE /sites/{siteId} -> updated list
  STATS: apiUrl + '/stats/account/summary',
  SITE_SUMMARY: apiUrl + '/stats', // GET /stats/{siteId}/summary?from&to; GET /stats/{siteId}/consents/{consentId}
}

const SUPPORT_ENDPOINTS = {
  NEW_TICKET: apiUrl + '/support/ticket',
}

const USER_ENDPOINTS = {
  LIST: apiUrl + '/users/list',
  ADD: apiUrl + '/users/add',
  UPDATE_ROLE: apiUrl + '/users/update-role',
  REMOVE: apiUrl + '/users/remove',
}

const STORAGE_KEYS = {
  LOGGED_IN_USER: 'LOGGED_IN_USER',
  REDIRECT_ROUTE: 'REDIRECT_ROUTE',
  AUTH0_LOGIN_CACHE: 'AUTH0_LOGIN_CACHE',
  ME_ACCOUNT_CACHE: 'ME_ACCOUNT_CACHE',
  VERSION_CONTROL_ID: 'VERSION_CONTROL_ID',
  SCAN_REGISTRY: 'SCAN_REGISTRY',
  TRIAL_BANNER_DISMISSED: 'TRIAL_BANNER_DISMISSED',
}

const API_ERRORS = {
  AUTH_EXPIRED: 'Authentication Expired',
  AUTH_ERROR: 'Authentication Error',
  UNAUTHORIZED: 'Unauthorized',
  TRIAL_EXPIRED: 'trial_expired',
  REQ_ERROR: 'API Request Error',
  NETWORK_ERROR: 'Network Error',
  CORS_ERROR: 'CORS Error',
  LOGOUT_AUTH_ERROR: 'Logout AUTH0 Error',
  LOGIN_AUTH_ERROR: 'Login AUTH0 Error',
}

// TODO(cookie-armor): seed real Cookie Armor analytics events as product surfaces land.
// When: Phase 9+ once a feature emits its first event.
const ANALYTICS_EVENTS = {}

// Used for both [bracket prefix] in error_name AND error_type (Error.name in PostHog)
const ERROR_TYPES = {
  API: 'API Request Error',
  AUTH: 'Authentication Error',
  VUE: 'Vue Error',
  QUERY: 'Query Error',
  MUTATION: 'Mutation Error',
  FIREBASE: 'Firebase Error',
  UNCAUGHT: 'Uncaught Error',
  VERSION_MISMATCH: 'VersionMismatchError',
  OFFLINE: 'OfflineError',
}
